import {
  Notices,
  Users,
  UserSkills,
} from '@/api/spotwrite';
import useFormatFunc from './Formatter';

export default function useNoticesFunc() {
  const formatter = useFormatFunc();

  /**
   * 公開日を返します.
   * @param item
   * @returns
   */
  function getPublishDate(item?: Notices) {
    if (item && item.publish) {
      return formatter.formatDate(item.publish, 'YYYY.MM.DD');
    }
    return 0;
  }

  return {
    getPublishDate,
  };
}
